/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React from 'react';
import { InView } from 'react-intersection-observer';
import { getScrollPosition, getY, ProjectItemInterface, scrollGetY, setY } from 'utils/scrolling';
import AppStyle from 'scss/main/App.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

interface ProjectItemProps {
  items: ProjectItemInterface[],
  elasticity: number
}

const ProjectStaggeredItems: React.FC<ProjectItemProps> = props => {
  
  const scrollY = useSelector((state: RootState) => state.ui.scrollY);

  var imageSet: number[] = new Array(props.items.length)

  for (var i = 0; i < props.items.length; i++) {
    imageSet[i] = (props.items[i].ref && props.items[i].ref.current && props.items[i].ref.current.offsetTop) || 0

    if (getY(`image${i + 1}Y`) !== imageSet[i] && imageSet[i] !== 0) {
      setY(`image${i + 1}Y`, imageSet[i])
    }
  }

  return (
    <div className={AppStyle["project-box"]}>
      {props.items.map((d, i) => <div key={`projectitem-${i}`}>
        <div>
          <InView triggerOnce>
            {({ inView, ref, entry }) => (
              <div ref={ref}>
                <img src={process.env.REACT_APP_CDN_PATH + d.src} ref={d.ref} style={{ willChange: 'transform', transform: !inView ? 'translate3d(0px, -5%, 0px)' : `translate3d(0px, ${scrollGetY(getScrollPosition(), getY(`image${i + 1}Y`), props.elasticity)}%, 0px)` }} />
              </div>
            )}
          </InView>
          <div>
            {d.title}
          </div>
        </div>
      </div>)}
    </div>
  )
}

export default ProjectStaggeredItems